// extracted by mini-css-extract-plugin
export var sm = "768";
export var md = "1024";
export var lg = "1280";
export var xl = "1600";
export var wrapper = "IntroductionSection-module--wrapper--rCtwC";
export var infoWrapper = "IntroductionSection-module--infoWrapper--neOXh";
export var title = "IntroductionSection-module--title--GP4Wd";
export var introWrapper = "IntroductionSection-module--introWrapper--XnvgR";
export var image = "IntroductionSection-module--image--nqrYX";
export var servicesWrapper = "IntroductionSection-module--servicesWrapper--jvB7z";
export var specialtiesWrapper = "IntroductionSection-module--specialtiesWrapper--OLjGa";
export var buttonWrapper = "IntroductionSection-module--buttonWrapper--5M3hT";
export var icon = "IntroductionSection-module--icon--h0emK";
export var cardInfo = "IntroductionSection-module--cardInfo--AYRDP";
export var cardTitle = "IntroductionSection-module--cardTitle--ESW1g";
export var decorationWrapper = "IntroductionSection-module--decorationWrapper--OJ34A";